var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "predictiveSearchModal", staticClass: "predictive-search-modal" },
    [
      _c("fade-transition", [
        _vm.showModal
          ? _c("div", { staticClass: "predictive-search-modal__content" }, [
              _c(
                "a",
                {
                  staticClass:
                    "predictive-search__header body-md-mobile color-black",
                  attrs: { href: _vm.moreResultsHref }
                },
                [
                  _vm._v("Search for"),
                  _c(
                    "span",
                    { staticClass: "predictive-search__header-text" },
                    [_vm._v('"' + _vm._s(_vm.searchTerm) + '"')]
                  )
                ]
              ),
              _c("div", { staticClass: "predictive-search__content" }, [
                _vm.searchSuggestions.length > 0 ||
                _vm.searchProducts.length > 0
                  ? _c(
                      "div",
                      {
                        staticClass: "predictive-search__suggestions-container"
                      },
                      [
                        _c("h6", { staticClass: "predictive-search__title" }, [
                          _vm._v("Suggestions")
                        ]),
                        _vm.searchSuggestions.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "predictive-search__suggestions-list"
                              },
                              _vm._l(_vm.searchSuggestions, function(
                                suggestion,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: suggestion.id,
                                    staticClass:
                                      "predictive-search__suggestions-list-item",
                                    class: {
                                      "predictive-search__suggestions-list-item--link":
                                        index === _vm.maxResults - 1
                                    }
                                  },
                                  [
                                    index < _vm.maxResults - 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "predictive-search__suggestions-list-item--textlink",
                                            attrs: { href: suggestion.url }
                                          },
                                          [_vm._v(_vm._s(suggestion.title))]
                                        )
                                      : _c(
                                          "v-link",
                                          {
                                            staticClass:
                                              "link predictive-search__products-list-item-more-result suggestion-more-result more-result",
                                            attrs: {
                                              primary: true,
                                              href: _vm.moreResultsHref
                                            }
                                          },
                                          [_vm._v("More results")]
                                        )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "predictive-search__text" },
                              [
                                _vm._v(
                                  'There are no suggestions for "' +
                                    _vm._s(_vm.searchTerm) +
                                    '"'
                                )
                              ]
                            )
                      ]
                    )
                  : _vm._e(),
                _vm.searchSuggestions.length > 0 ||
                _vm.searchProducts.length > 0
                  ? _c(
                      "div",
                      { staticClass: "predictive-search__products-container" },
                      [
                        _c("h6", { staticClass: "predictive-search__title" }, [
                          _vm._v("Products")
                        ]),
                        _vm.searchProducts.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "predictive-search__products-list"
                              },
                              _vm._l(_vm.searchProducts, function(
                                product,
                                index
                              ) {
                                return _c(
                                  "div",
                                  {
                                    key: product.id,
                                    staticClass:
                                      "predictive-search__products-list-item",
                                    class: {
                                      "predictive-search__products-list-item--link":
                                        index === _vm.maxResults - 1
                                    }
                                  },
                                  [
                                    index < _vm.maxResults - 1
                                      ? _c(
                                          "a",
                                          {
                                            staticClass:
                                              "predictive-search__product-link",
                                            attrs: { href: product.url }
                                          },
                                          [
                                            _c("product-tile", {
                                              attrs: {
                                                widget: true,
                                                truncateTitle: false,
                                                product: product,
                                                "hide-badges": ""
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _c(
                                          "v-link",
                                          {
                                            staticClass:
                                              "link predictive-search__products-list-item-more-result more-result",
                                            attrs: {
                                              primary: true,
                                              href: _vm.moreResultsHref
                                            }
                                          },
                                          [_vm._v("More results")]
                                        )
                                  ],
                                  1
                                )
                              }),
                              0
                            )
                          : _c(
                              "div",
                              { staticClass: "predictive-search__text" },
                              [
                                _vm._v(
                                  'There are no products for "' +
                                    _vm._s(_vm.searchTerm) +
                                    '"'
                                )
                              ]
                            )
                      ]
                    )
                  : _vm._e(),
                _vm.searchSuggestions.length <= 0 &&
                _vm.searchProducts.length <= 0
                  ? _c("h6", { staticClass: "predictive-search__text" }, [
                      _vm._v(
                        'There are no results for "' +
                          _vm._s(_vm.searchTerm) +
                          '"'
                      )
                    ])
                  : _vm._e()
              ])
            ])
          : _vm._e()
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }